import { Tracker } from '@pegasus/tracker';
class BrowsingTracker extends Tracker {
}
export const tracker = new BrowsingTracker();
